module.exports = __webpack_public_path__ + "img/hr-tree-08-c-trunk.1a73de30.png";